import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SigninDto } from "./Signin.Dto";
import { AutenticacaoModule } from "src/Contexto/auth";
import { MapearErrosServidor } from "src/hook/Functions";
import { showToast } from "src/componentes";
import { UsuarioEnviarConfirmacaoEmail } from "src/services/Identity.Service";

const SiginInCode = () => {
  const [loading, setLoading] = useState(false);
  const { signIn } = AutenticacaoModule();
  const navigate = useNavigate();

  const onClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const onSubmit = (data: SigninDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    signIn(data)
      .then((response) => {
        if (response.success) {
          UsuarioEnviarConfirmacaoEmail({ email: data.email } as any)
            .then((emailRes) => {
              if (emailRes.success) {
                showToast({
                  message: "E-mail de confirmação enviado, verifique seu e-mail!",
                  variant: "Info",
                });
              } else {
                showToast({
                  message: emailRes.notifications[0].message,
                  title: "Aviso",
                  variant: "Warning",
                });
              }
              navigate("/confirmar-email", { state: { email: data.email } });
            })
            .catch((err) => {
              console.error("Erro ao enviar e-mail de ativação:", err);
              showToast({
                message:
                  "Cadastro realizado com sucesso, mas não conseguimos enviar o e-mail de ativação. Você pode reenviá-lo na próxima página.",
                title: "Aviso",
                variant: "Warning",
              });
              navigate("/confirmar-email", { state: { email: data.email } });
            });
        } else {
          MapearErrosServidor(response.notifications, showToast);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    onSubmit,
    loading,
    onClickNavigate,
  };
};
export default SiginInCode;
